module.exports = __webpack_public_path__ + "static/media/lockIconLight.55d303cc.svg";